import React from "react";

function Location() {
  return (
    <>
      <svg
        width="13"
        height="15"
        viewBox="0 0 13 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.3048 10.6591L6.07057 14.9103L1.81945 10.6761C0.97867 9.83863 0.405101 8.77067 0.171275 7.60725C-0.0625514 6.44383 0.0538663 5.2372 0.505807 4.13994C0.957747 3.04269 1.72491 2.10409 2.71029 1.44284C3.69566 0.781585 4.85499 0.42738 6.04168 0.425013C7.22836 0.422646 8.3891 0.772224 9.3771 1.42954C10.3651 2.08686 11.136 3.02239 11.5923 4.11783C12.0486 5.21328 12.1699 6.41943 11.9407 7.58378C11.7115 8.74812 11.1422 9.81835 10.3048 10.6591ZM6.05896 9.09161C6.76621 9.0902 7.44392 8.8079 7.94302 8.3068C8.44212 7.80571 8.72172 7.12687 8.72031 6.41963C8.7189 5.71239 8.43659 5.03467 7.9355 4.53557C7.4344 4.03648 6.75557 3.75688 6.04833 3.75829C5.34108 3.7597 4.66337 4.042 4.16427 4.5431C3.66517 5.04419 3.38557 5.72303 3.38698 6.43027C3.38839 7.13751 3.6707 7.81523 4.17179 8.31432C4.67289 8.81342 5.35172 9.09302 6.05896 9.09161ZM6.0563 7.75828C5.70268 7.75898 5.36327 7.61919 5.11272 7.36964C4.86217 7.12009 4.72102 6.78123 4.72031 6.42761C4.71961 6.07399 4.85941 5.73457 5.10896 5.48402C5.35851 5.23348 5.69736 5.09232 6.05099 5.09162C6.40461 5.09091 6.74402 5.23071 6.99457 5.48026C7.24512 5.72981 7.38627 6.06867 7.38698 6.42229C7.38768 6.77591 7.24788 7.11533 6.99833 7.36588C6.74878 7.61642 6.40993 7.75757 6.0563 7.75828Z"
          fill="#0DAFC0"
        />
      </svg>
    </>
  );
}

export default Location;
